export default __webpack_public_path__ + "assets/images/832d54080d6b1c0d3f48be51dbf62aba.png";